
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_32107","data-name":"Group 32107","xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_9336","data-name":"Rectangle 9336","width":"18","height":"18","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_32106","data-name":"Group 32106","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_21107","data-name":"Path 21107","d":"M13.382 11.317a2.831 2.831 0 00-2.153 1.006l-3.957-2.318a2.749 2.749 0 000-2.011l3.953-2.316a2.83 2.83 0 002.153 1.005 2.846 2.846 0 10-2.014-4.857 2.8 2.8 0 00-.649 2.991L6.756 7.139c-.043-.05-.078-.105-.125-.151a2.824 2.824 0 00-2.012-.835 2.846 2.846 0 102.135 4.707l3.965 2.324a2.836 2.836 0 002.666 3.825 2.846 2.846 0 000-5.692m-1.31-8.785a1.846 1.846 0 111.307 3.151 1.846 1.846 0 01-1.306-3.151m-7.459 8.313a1.846 1.846 0 010-3.692 1.846 1.846 0 010 3.692m8.763 5.164a1.846 1.846 0 010-3.692 1.846 1.846 0 010 3.692","fill":"#5a677d"}})])])
          )
        }
      }
    